export default Object.freeze([
    {
        key: '1a',
        variant: 1,
        d: 'M182 0l232 148h564L1215 0z',
        'fill-opacity': 0.15,
    },
    {
        key: '1b',
        variant: 1,
        d: 'M52.324 263h1303.788L1400 234H0z',
        'fill-opacity': 0.1,
    },
    {
        key: '1c',
        variant: 1,
        d: 'M52 263h1304v117H52z',
        'fill-opacity': 0.15,
    },
    {
        key: '2a',
        variant: 2,
        d: 'M0 248l539.081-135.517 228.961 93.89L774 380H0z',
        'fill-opacity': 0.15,
    },
    {
        key: '2b',
        variant: 2,
        d: 'M906 380l37.282-42.899 336.66-114.224L1387 380zM704 0h411l22.045 30.027-368.936 176-228.746-93.66',
        'fill-opacity': 0.1,
    },
    {
        key: '2c',
        variant: 2,
        d: 'M1279.71 222.74L1137.046 30.027 768.28 206.235l4.508 141.668 274.51-99.31 9.617 49.83',
        'fill-opacity': 0.2,
    },
    {
        key: '3a-left',
        variant: 3,
        d: 'M391 0H0v380h37l354-180z',
        'fill-opacity': 0.1,
    },
    {
        key: '3b-right',
        variant: 3,
        d: 'M1009 0h391v380h-37l-354-180z',
        'fill-opacity': 0.1,
    },
    {
        key: '3c-center',
        variant: 3,
        d: 'M391 0h618v200H391z',
        'fill-opacity': 0.15,
    },
    {
        key: '4a',
        variant: 4,
        d: 'M0 0v380h381l9-81L136 0z',
        'fill-opacity': 0.15,
    },
    {
        key: '4b',
        variant: 4,
        d: 'M338 0l73 121H239L136 0z',
        'fill-opacity': 0.1,
    },
    {
        key: '4c',
        variant: 4,
        d: 'M1086 0l-63 121h159l97-121zM425 0l-44 380h666L1011 0z',
        'fill-opacity': 0.1,
    },
    {
        key: '4d',
        variant: 4,
        d: 'M1400 0v380h-353l-8-84L1279 0z',
        'fill-opacity': 0.15,
    },
    {
        key: '5a',
        variant: 5,
        d: 'M0 179v201h470V245z',
        'fill-opacity': 0.15,
    },
    {
        key: '5b',
        variant: 5,
        d: 'M0 179l658 92 316-32L226 0H0z',
        'fill-opacity': 0.1,
    },
    {
        key: '5c',
        variant: 5,
        d: 'M225 0l748 238 1-238z',
        'fill-opacity': 0.15,
    },
    {
        key: '5d',
        variant: 5,
        d: 'M1400 268l-928 61-1 51h929z',
        'fill-opacity': 0.1,
    },
]);



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/components/cms-placeholders/entry-animation/pathes.js